jQuery(document).ready(function($) {
  // $('.product-single__title').html($('.product-single__title').html().replace('[', '<br/>['));

  $('.product-single__description .tab-title').click(function() {
    $(this).closest('.tab').toggleClass('active');
    $(this).closest('.tab').find('.content').slideToggle();
    // $(this).parent('.tab').find('.content').slideUp();
    // $(this).closest('.tab').toggleClass('active').siblings().removeClass('active');
    // $(this).closest('.tab').siblings().find('.content').slideUp();
    // $(this).closest('.tab').find('.content').slideToggle();
  });
  
  $('.why-us .list-item .item .image').matchHeight('');
  $('.why-us .list-item .item .title').matchHeight('');
  $('.photos-mobile-slider').owlCarousel({
    loop:true,
    margin:0,
    nav:false,
    dots:false,
    items:1
  })
})